<template>
  <div class="sova-club-thanks">
    <svg class="sova-club-thanks__logo"><use xlink:href="#svg-sova-club-logo"></use></svg>
    <h2 class="sova-club-thanks__title">{{ messages.thanksTitle }}</h2>
    <p class="sova-club-thanks__text">
      {{ messages.thanksText }}
    </p>
    <DefButtonPrimary @click="$emit('close')"> ок </DefButtonPrimary>
  </div>
</template>

<script setup>
import DefButtonPrimary from '@components/Def/DefButtonPrimary/DefButtonPrimary.vue';
import { useStore } from '@store';

const {
  state: {
    results: {
      messages: { sovaClub: messages },
    },
  },
} = useStore();
</script>

<script>
export default {
  name: 'SovaClubThanks',
};
</script>

<style lang="scss" scoped>
.sova-club-thanks {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  height: 100%;
  &__title {
    font-weight: 600;
    font-size: rem(16);
    letter-spacing: 0.04em;
    text-transform: uppercase;
    margin-bottom: 8px;
    @include point-md {
      font-size: rem(24);
      margin-bottom: 16px;
    }
  }
  &__logo {
    display: block;
    width: 108px;
    height: 154px;
    margin-bottom: 50px;
    flex-shrink: 0;
    @include point-md {
      width: 174px;
      height: 250px;
      margin-bottom: 88px;
    }
  }
  &__text {
    font-size: rem(12);
    line-height: 130%;
    margin-bottom: 32px;
    @include point-md {
      font-size: rem(14);
    }
  }
  :deep(.def-button-primary) {
    width: 100%;
    flex-shrink: 0;
    @include point-md {
      width: auto;
      min-width: 180px;
    }
  }
}
</style>
